import { render, staticRenderFns } from "./LamsBaseLegalCategory.vue?vue&type=template&id=456f8045&scoped=true&"
import script from "./LamsBaseLegalCategory.vue?vue&type=script&lang=js&"
export * from "./LamsBaseLegalCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f8045",
  null
  
)

export default component.exports